/** Tri-state labels for boolean column filters (e.g. is_excluded). Used by data-table FilterType.BOOLEAN. */
export const TRI_STATE_BOOLEAN_FILTER_OPTIONS = [
    { label: 'All', value: null as boolean | null },
    { label: 'Yes', value: true },
    { label: 'No', value: false },
];
